module.exports = {
  draftsList: 'List of Deactivations',
  closedList: 'Closed List',
  editImage: {
    title: 'Edit Image',
  },
  header: {
    title: 'Product',
    buttonCreate: 'Create',
    buttonPublish: 'Publish',
    buttonUpdate: 'Update',
  },
  table: {
    title: {
      index: 'NO',
      show: 'Active',
      title: 'TITLE',
      link: 'DEEP LINK TYPE',
      partner: 'PARTNER',
      status: 'STATUS',
      action: 'ACTION',
      country: 'COUNTRY',
    },
    tooltip: {
      edit: 'Edit',
      delete: 'Delete',
      inactive: 'InActive',
      active: 'Active',
    },
    popup: {
      title: 'Confirm',
      okBtn: 'Yes',
      cancelBtn: 'No',
      delete: 'Are you sure to delete this Home Product?',
      edit: 'Are you sure to edit this Home Product?',
      enable: 'Are you sure you want to enable this Home Product?',
      disable: 'Are you sure you want to disable this Home Product?',
      confirmPassword: 'Please input your password to confirm.',
    },
  },
  form: {
    image1x1: 'Please upload a 1x1 image',
    imageUpload: '*Upload an image',
    title: 'Title',
    subTitle: 'Subtitle',
    link: 'Link',
    linkType: 'Page Type',
    countries: 'Countries',
    country: 'Country',
    btnUpdateHomeProduct: 'Update',
    btnCreateHomeProduct: 'Add',
    updateHomeProduct: 'Edit Home Product',
    createHomeProduct: 'Add Home Product',
    backgroundColor: 'Background Color',
    titleColor: 'Title Color',
    subColor: 'Subtitle Color',
    cta: 'CTA',
    ctaTextColor: 'CTA Text Color',
    ctaBackgroundColor: 'CTA Background Color',
    tag: 'Tag',
    logo: 'Logo',
    upload: 'Upload',
  },
  validate: {
    titleBlank: 'Please input title!',
    tagBlank: 'Please input tag!',
    countryBlank: 'Please select country!',
    linkBlank: 'Please input a link!',
    linkTypeBlank: 'Please select page type!',
    imageBlank: 'Please input an image!',
    ctaBlank: 'Please input a CTA!',
    buttonList: 'Please input Button (All Home Product) text!',
    buttonDetail: 'Please input Button (Home Product Details) text!',
  },
  message: {
    error: {
      uploadImage: 'There was an error while uploading the image. Please try again',
      requireUpload: 'Please upload an image',
      updateProductEcomError: 'Failed to update ECOM product.',
    },
    success: {
      updateHomeProduct: 'Home Product successfully updated.',
      createHomeProduct: 'Home Product successfully added.',
      deleteHomeProduct: 'Home Product successfully deleted.',
      updateProductEcomSuccess: 'ECOM Product successfully updated.',
    },
  },
};
